import { ROUTES } from '@/app/routes';
import Pressable from '@/components/motion/pressable';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PageScroll } from '@/layouts/page-layout';
import { ChevronRightIcon, BarChart3Icon, SettingsIcon, UsersIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import BulkActionsWidget from './bulk-actions-widget';
import ProfitWidget from './profit-widget';

export default function AdminPage() {
	const navigate = useNavigate();

	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			<Pressable
				className='cursor-pointer active:bg-accent/30 rounded-xl'
				onClick={() => navigate(ROUTES.adminUsers)}
			>
				<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
					<CardHeader className='border-b px-4 py-4 flex'>
						<div className='flex items-center justify-between gap-3 w-full'>
							<div className='flex items-center gap-3'>
								<div className='rounded-lg bg-chart-2/15 p-2'>
									<UsersIcon className='text-chart-2' size={20} />
								</div>
								<div>
									<CardTitle className='text-chart-2'>Пользователи</CardTitle>
									<CardDescription>Список, статистика, роли</CardDescription>
								</div>
							</div>
							<ChevronRightIcon size={18} className='text-muted-foreground shrink-0' />
						</div>
					</CardHeader>
					<CardContent className='px-4 py-3 text-sm text-muted-foreground'>
						Клиенты, билды, профиты и управление ролями
					</CardContent>
				</Card>
			</Pressable>
			<Pressable
				className='cursor-pointer active:bg-accent/30 rounded-xl'
				onClick={() => navigate(ROUTES.adminStats)}
			>
				<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
					<CardHeader className='border-b px-4 py-4 flex'>
						<div className='flex items-center justify-between gap-3 w-full'>
							<div className='flex items-center gap-3'>
								<div className='rounded-lg bg-chart-1/15 p-2'>
									<BarChart3Icon className='text-chart-1' size={20} />
								</div>
								<div>
									<CardTitle className='text-chart-1'>Статистика</CardTitle>
									<CardDescription>Графики и аналитика</CardDescription>
								</div>
							</div>
							<ChevronRightIcon size={18} className='text-muted-foreground shrink-0' />
						</div>
					</CardHeader>
					<CardContent className='px-4 py-3 text-sm text-muted-foreground'>
						Клиенты, профиты, билды и воркеры
					</CardContent>
				</Card>
			</Pressable>
			<Pressable
				className='cursor-pointer active:bg-accent/30 rounded-xl'
				onClick={() => navigate(ROUTES.adminSettings)}
			>
				<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
					<CardHeader className='border-b px-4 py-4 flex'>
						<div className='flex items-center justify-between gap-3 w-full'>
							<div className='flex items-center gap-3'>
								<div className='rounded-lg bg-chart-4/15 p-2'>
									<SettingsIcon className='text-chart-4' size={20} />
								</div>
								<div>
									<CardTitle className='text-chart-4'>Настройки</CardTitle>
									<CardDescription>Модули и параметры проекта</CardDescription>
								</div>
							</div>
							<ChevronRightIcon size={18} className='text-muted-foreground shrink-0' />
						</div>
					</CardHeader>
					<CardContent className='px-4 py-3 text-sm text-muted-foreground'>
						Билдер, пользователи и другие настройки системы
					</CardContent>
				</Card>
			</Pressable>
			<ProfitWidget />
			<BulkActionsWidget />
		</PageScroll>
	);
}
